/**
 * idp 子应用的 i18n 资源初始化
 *
 * 必须在任何业务模块（尤其是在模块顶层调用 `i18n.t(...)` 的模块）被 import 之前执行。
 * 通过 side-effect import 的形式放在 bootstrap.tsx 的 import 列表最前面，
 * 利用 ES Module 的深度优先加载顺序确保在 `idpBase/store` 等业务模块求值前完成资源注册。
 */
import { initOneidUtilsLang, LANG_TYPE } from '@tencent/oneid-utils';
import { addResources, setDocumentTitle } from 'common/locales';
import { LANG_STORAGE_KEY } from 'common/locales/constant';
import enUSIdp from 'common/locales/en-US/idp';
import enUSSemiUi from 'common/locales/en-US/semi-ui';
import zhHKIdp from 'common/locales/zh-HK/idp';

initOneidUtilsLang(LANG_STORAGE_KEY);
addResources('idp', enUSIdp);
addResources('idp', zhHKIdp, LANG_TYPE.ZH_HK);
addResources('semi-ui', enUSSemiUi);

setDocumentTitle('腾讯统一身份');
